
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-dark">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
          backgroundImage: `linear-gradient(rgba(148, 163, 184, 0.1) 1px, transparent 1px),
                           linear-gradient(90deg, rgba(148, 163, 184, 0.1) 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      {/* Radial Gradient */}
      <div className="absolute inset-0 bg-gradient-radial from-primary/10 via-transparent to-transparent"></div>

      {/* Floating Elements */}
      <div className="absolute top-20 left-20 w-32 h-32 bg-primary/20 rounded-full blur-3xl animate-float"></div>
      <div className="absolute bottom-40 right-40 w-40 h-40 bg-primary/15 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }}></div>
      <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-primary/10 rounded-full blur-2xl animate-float" style={{ animationDelay: '2s' }}></div>

      <div className="max-w-[1400px] mx-auto px-8 py-32 relative z-10">
        <div className="grid grid-cols-2 gap-16 items-center">
          {/* Left Side - Text Content */}
          <div className="space-y-8">
            <h1 className="text-6xl font-extrabold leading-tight">
              <span className="text-white">Ihre </span>
              <span className="bg-gradient-to-r from-primary to-primary-light bg-clip-text text-transparent">
                individuelle SaaS-Lösung.
              </span>
              <span className="text-white"> Perfekt auf Ihr Business zugeschnitten.</span>
            </h1>
            
            <p className="text-xl text-gray-400 leading-relaxed font-light">
              Wir entwickeln maßgeschneiderte Software-Lösungen, die exakt zu Ihren Prozessen passen – von CRM-Systemen über Automatisierungstools bis hin zu kompletten Business-Plattformen. Keine Kompromisse, keine unnötigen Features.
            </p>

            {/* USP List */}
            <div className="space-y-4 pt-2">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center flex-shrink-0">
                  <i className="ri-puzzle-line text-primary text-xl"></i>
                </div>
                <div>
                  <h3 className="text-white font-semibold text-lg">100% maßgeschneidert</h3>
                  <p className="text-gray-400 text-sm">Jede Funktion wird individuell für Ihre Anforderungen entwickelt – keine Standard-Templates.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center flex-shrink-0">
                  <i className="ri-stack-line text-primary text-xl"></i>
                </div>
                <div>
                  <h3 className="text-white font-semibold text-lg">Moderne Technologie-Stack</h3>
                  <p className="text-gray-400 text-sm">Supabase, Stripe, Shopify, KI-Integration – wir nutzen führende Technologien für maximale Performance.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center flex-shrink-0">
                  <i className="ri-rocket-line text-primary text-xl"></i>
                </div>
                <div>
                  <h3 className="text-white font-semibold text-lg">Schnelle Umsetzung</h3>
                  <p className="text-gray-400 text-sm">Von der Konzeption bis zum Launch in Wochen statt Monaten – agile Entwicklung ohne Qualitätsverlust.</p>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-6 pt-4">
              <Link
                to="/demo"
                className="px-10 h-14 bg-primary hover:bg-primary-dark text-white rounded-xl font-semibold text-lg transition-all duration-300 hover:shadow-2xl hover:shadow-primary/50 flex items-center gap-3 cursor-pointer whitespace-nowrap hover:scale-105"
              >
                Demo ansehen
                <i className="ri-arrow-right-line text-xl"></i>
              </Link>
              
              <a
                href="#contact"
                className="px-10 h-14 border-2 border-white/20 hover:border-primary text-white rounded-xl font-semibold text-lg transition-all duration-300 flex items-center gap-3 cursor-pointer whitespace-nowrap hover:bg-white/5"
              >
                Kostenloses Erstgespräch
              </a>
            </div>
          </div>

          {/* Right Side - Dashboard Mockup */}
          <div className="relative">
            <div className="relative transform rotate-3 hover:rotate-0 transition-transform duration-500">
              {/* Browser Frame */}
              <div className="bg-gradient-to-b from-gray-200 to-gray-300 rounded-t-2xl p-3 shadow-2xl">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-3 h-3 rounded-full bg-red-500"></div>
                  <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                  <div className="w-3 h-3 rounded-full bg-green-500"></div>
                </div>
                <div className="bg-white rounded-lg px-4 py-2 flex items-center gap-2">
                  <i className="ri-lock-line text-gray-400 text-sm"></i>
                  <span className="text-gray-600 text-sm">app.saas-solutions.com/dashboard</span>
                </div>
              </div>

              {/* Dashboard Screenshot */}
              <div className="bg-dark-lighter rounded-b-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/af69f82acc6d6ff4a9d6c43788d30db0.jpg"
                  alt="Dashboard Preview"
                  className="w-full h-auto object-cover object-top"
                />
              </div>

              {/* Glow Effect */}
              <div className="absolute -inset-4 bg-gradient-to-r from-primary/20 to-primary-light/20 rounded-3xl blur-3xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
